import Vue from 'vue'
import _ from 'lodash'

const VueLodash = {

  install(Vue, options) {

    Vue.prototype.$_ = _

  }

}

Vue.use(VueLodash)

export default VueLodash



// WEBPACK FOOTER //
// ./src/initializers/lodash.js